export default {
    accounts_main_id: 'Id',
    accounts_main_name: 'Nombre',
    accounts_main_dealer: 'Distribuidor',
    accounts_main_brand: 'Marca',
    accounts_main_status: 'Estado',
    accounts_main_companies: 'Compañias',
    accounts_main_accounts: 'Cuentas',
    accounts_main_advanced_filters: 'Filtros avanzados',
    accounts_main_apply: 'Aplicar',
    accounts_main_tags: 'Etiquetas',
    accounts_main_active_accounts_only: 'Sólo cuentas activas',
    accounts_main_yes: 'Si',
    accounts_main_no: 'No',
    accounts_main_authenticate_cloud: 'Iniciar sesión como cliente',
    accounts_main_re_sync_backend_information: 'Re-sincronización de la información del backend',
    accounts_main_devices: 'Dispositivos',
    accounts_main_package: 'Paquete',
    accounts_main_crm: 'Id. de Salesforce',
    accounts_main_add_account: 'Agregar cuenta',
    accounts_main_import_account: 'Importar cuenta',
    accounts_main_edit: 'Editar',
    accounts_main_remove_filters: 'Eliminar los filtros',
    accounts_main_account_details: 'Detalles de la cuenta',
    accounts_main_import_from_p4: 'Importar desde P4',
    accounts_main_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    accounts_main_new_status: 'Nuevo Estado',
    accounts_main_at: 'el',
    accounts_main_next_scheduled_action: 'Próxima acción programada',
    accounts_main_on: 'en',
    accounts_main_tags: 'Etiquetas',
    accounts_main_syncZonar: 'Sincronizar con Zonar',
    accounts_main_error_integration_zonar: 'No hay integración con Zonar',
    accounts_main_readonly: 'Solo Lectura',
    accounts_main_edge_tensor: 'Tensor de Borde',
    accounts_main_status_filter: 'Estado de cuenta'
};